const state = () => ({
  partnerSelected: null,
  hrbEmail: '',
  hrbCode: '',
  authorizationMethod: null,
  externalAuthorizationLanguageKey: null,
  authorizationType: '',
  dialogTitle: '',
  dialogButtons: [],
  dialogLoading: false,
  dialogLeftHeaderIcon: '',
  dialogLeftHeaderIconType: 'static',
  dialogLeftHeaderIconComponent: '',
  headerType: 'navigation',
  otherPartners: [],
  mainPartners: []
});

const getters = {
  partnerSelected(state) {
    return state.partnerSelected;
  },
  hrbEmail(state) {
    return state.hrbEmail;
  },
  hrbCode(state) {
    return state.hrbCode;
  },
  authorizationMethod(state) {
    return state.authorizationMethod;
  },
  externalAuthorizationLanguageKey(state) {
    return state.externalAuthorizationLanguageKey;
  },
  authorizationType(state) {
    return state.authorizationType;
  },
  dialogTitle(state) {
    return state.dialogTitle;
  },
  dialogButtons(state) {
    return state.dialogButtons;
  },
  dialogLoading(state) {
    return state.dialogLoading;
  },
  dialogLeftHeaderIcon(state) {
    return state.dialogLeftHeaderIcon;
  },
  dialogLeftHeaderIconType(state) {
    return state.dialogLeftHeaderIconType;
  },
  dialogLeftHeaderIconComponent(state) {
    return state.dialogLeftHeaderIconComponent;
  },
  headerType(state) {
    return state.headerType;
  },
  otherPartners(state) {
    return state.otherPartners;
  },
  mainPartners(state) {
    return state.mainPartners;
  }
};

const mutations = {
  setPartnerSelected(state, payload) {
    state.partnerSelected = payload;
  },
  setHrbEmail(state, payload) {
    state.hrbEmail = payload;
  },
  setHrbCode(state, payload) {
    state.hrbCode = payload;
  },
  setAuthorizationMethod(state, payload) {
    state.authorizationMethod = payload;
  },
  setExternalAuthorizationLanguageKey(state, payload) {
    state.externalAuthorizationLanguageKey = payload;
  },
  setAuthorizationType(state, payload) {
    state.authorizationType = payload;
  },
  setDialogTitle(state, payload) {
    state.dialogTitle = payload;
  },
  setDialogButtons(state, payload) {
    state.dialogButtons = payload;
  },
  setDialogLoading(state, payload) {
    state.dialogLoading = payload;
  },
  setDialogLeftHeaderIcon(state, payload) {
    state.dialogLeftHeaderIcon = payload;
  },
  setDialogLeftHeaderIconType(state, payload) {
    state.dialogLeftHeaderIconType = payload;
  },
  setDialogLeftHeaderIconComponent(state, payload) {
    state.dialogLeftHeaderIconComponent = payload;
  },
  setHeaderType(state, payload) {
    state.headerType = payload;
  },
  setOtherPartners(state, payload) {
    state.otherPartners = payload;
  },
  setMainPartners(state, payload) {
    state.mainPartners = payload;
  },
  resetStore(s) {
    Object.assign(s, state());
  }
};

const actions = {
  setDialogTitle({ commit }, payload) {
    commit('setDialogTitle', payload);
  },
  setDialogButtons({ commit }, payload) {
    commit('setDialogButtons', payload);
  },
  setDialogLoading({ commit }, payload) {
    commit('setDialogLoading', payload);
  },
  setDialogLeftHeaderIcon({ commit }, payload) {
    commit('setDialogLeftHeaderIcon', payload);
  },
  setDialogLeftHeaderIconType({ commit }, payload) {
    commit('setDialogLeftHeaderIconType', payload);
  },
  setDialogLeftHeaderIconComponent({ commit }, payload) {
    commit('setDialogLeftHeaderIconComponent', payload);
  },
  setHeaderType({ commit }, payload) {
    commit('setHeaderType', payload);
  },
  setOtherPartners({ commit }, payload) {
    commit('setOtherPartners', payload);
  },
  setMainPartners({ commit }, payload) {
    commit('setMainPartners', payload);
  }
};

export const authorization = {
  state,
  getters,
  mutations,
  actions,
  namespaced: true
};
